import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, Outlet } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import { useProfileEnforcement } from '~/atoms/hooks/useProfileEnforcement';
/**
 * ProtectedRoute
 * --------------
 * A wrapper route component that checks Okta authentication state.
 * - If the user is authenticated, renders the child route (Outlet).
 * - If not authenticated, redirects to the login page.
 * Used to protect routes that require authentication.
 */
const ProtectedRoute = () => {
    const { authState } = useOktaAuth();
    useProfileEnforcement();
    if (!authState)
        return null;
    if (!authState.isAuthenticated)
        return _jsx(Navigate, { to: "/login", replace: true });
    return _jsx(Outlet, {});
};
export default ProtectedRoute;
